export const TIPO_ALERTA = {
    ADVERTENCIA: 'warning',
    ERROR: 'danger',
    EXITO: 'success',
    INFORMACION: 'info'
};

export const TIPO_MENSAJE_SWALL = {
    ADVERTENCIA: 'warning',
    ERROR: 'error',
    EXITO: 'success',
    INFORMACION: 'info'
}
export const mensajeInicial = {
    texto: '',
    tipo: '' // warning, danger, info, successfull
}
